import Masonry from 'masonry-layout';

var masonry = null;

(function (Drupal) {
    Drupal.behaviors.hubMasonry = {
        attach: function (context, settings) {
            once("views-masonry", ".view .view-content", context).forEach(function (element) 
            {
                // Check if its a masonry view
                if(!element.querySelector('.views-masonry')) {
                    return;
                }

                // Card size
                const sizer = 'masonry-sizer';
                const sizerElement = document.createElement('div');
                sizerElement.classList.add(sizer);

                // GAP between cards size
                const gutter = 'masonry-gutter';
                const gutterElement = document.createElement('div');
                gutterElement.classList.add(gutter);

                // Append elements
                element.appendChild(sizerElement);
                element.appendChild(gutterElement);

                // Initialize Masonry
                masonry = new Masonry(element, {
                    itemSelector: '.view .view-content article.node',
                    columnWidth: '.masonry-sizer',
                    gutter: '.masonry-gutter',
                    percentPosition: true
                });  
            });

            // Append new elements to Masonry
            if(masonry) {
                let needsRefresh = false;
                once("views-masonly", ".view .view-content article.node", context).forEach(function (element) {

                    const appended = masonry.getItemElements();
                    
                    // check if element is already appended        
                    if(!appended.includes(element)) {
                        masonry.appended(element);
                        needsRefresh = true;
                    }
                });
    
                if(needsRefresh) {
                    masonry.layout();
                }
            }
        },
    };
})(Drupal);
